import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import imgPath from "../../assets/images/site/careers.jpg";
import PhyelementsMain from "../PhyElements/PhyelementsMain";
import "./CareersPage.css";
import SiteFooter from '../OurServices/ASIC/SiteFooter';

export default function CareersPage() {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column"}}>
    <Box sx={{ flex: 1 }}>
    <PhyelementsMain />
    <Box sx={{display:'flex', justifyContent: "center", alignItems:'center', height:'100%', width:"100%" }}>    
      <Box className="careers-image-box"
        sx={{ position: 'relative',  height: { xs: "20vh", sm: "40vh", md: "50vh" }, opacity:0.7 }}>        
        <CardMedia
          component="img"          
          image={imgPath}
        />
        <Box
          sx={{
            position: 'absolute',
            top: "5%",
            left: 0,
            width: '100%',            
            color: '#000',
            padding: '10px',
          }}
        >          
          <Typography sx={{height:"40px", alignContent:"center", padding:"5px 10px 0px 10px", fontSize:{ xs: "0.9rem", sm: "1.2rem", md: "1.4rem" }}} >Thinking about a career in VLSI Semiconductors?</Typography>          
        </Box>
      </Box>
    </Box>
    <Box sx={{display:'flex', justifyContent: "center", alignItems:'center', padding:"20px", }}>
        <Typography color="text.secondary" lineHeight={2} sx={{fontSize:{ xs: "1rem", sm: "1.2rem", md: "1.5rem" }}}>
          We would love to have you become part of our dynamic community of bright and supportive colleagues.
        </Typography>
    </Box>
      <Box sx={{ display: "flex", justifyContent: "center", marginBottom:"10px"}}>
        <Typography color="text.secondary" lineHeight={2} sx={{ textAlign: "center", fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" }, }}>
          Email us your updated resume to{" "} <a href="mailto:careers@phyelements.com" style={{ textDecoration: "none" }}> careers@phyelements.com </a>
        </Typography>
      </Box>
    </Box>
    <SiteFooter/>
    </Box>
  );
}